const initialState = {
  loading: false,
  data: null,
  error: null,
};


const partnerPayoutListByFyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "PARTNER_PAYOUT_LIST_BY_FY_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case "PARTNER_PAYOUT_LIST_BY_FY_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default partnerPayoutListByFyReducer;